import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=f4e936ba&"
var script = {}
import style0 from "./imprint.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e936ba')) {
      api.createRecord('f4e936ba', component.options)
    } else {
      api.reload('f4e936ba', component.options)
    }
    module.hot.accept("./imprint.vue?vue&type=template&id=f4e936ba&", function () {
      api.rerender('f4e936ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imprint/imprint.vue"
export default component.exports